import Users from "../components/views/users/Users.vue";
import UserDetails from "../components/views/users/UserDetails.vue";
import UserCreate from "../components/views/users/UserCreate.vue";
import CreateUser from "../components/views/users/CreateUser.vue";

const routes = [
  {
    path: "users",
    component: Users,
    name: "Users",
    meta: {
      description: "List of Users",
      title: "User",
      requiresAuth: true,
    },
  },

  {
    path: "/users/create",
    component: UserCreate,
    name: "UserCreate",
    meta: {
      // description: "Add a new User",
      title: "Add / Update User",
      requiresAuth: true,
    },
  },
  {
    path: "/users/:_id",
    beforeEnter: (to, from, next) => {
      to.params._id === "create" ? next({ name: "UserCreate" }) : next();
    },
    component: UserDetails,
    name: "UserDetails",
    meta: {
      description: "Details for the selected User",
      title: "Update User",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/users.route.js